import React, { Component } from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('TRANSACTION_REPORT_EXTRASTAT', LOG_LEVELS.DEBUG);

class ReportExtrastat extends Component {

  render() {
    log.debug('render(): ', this.props);

    if (!this.props.src) {
      return(
        <div><LanguageStringResolver string='transactionBlank_noData'/></div>
      )
    }

    return(
      <div>
        {/*TODO Language Strings*/}
        {this.props.src.map((item, index) => (
          <table key={index} className="mb20">
            <thead>
              <tr>
                <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_item'/></th>
                <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_value'/></th>
                <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_item'/></th>
                <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_value'/></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_country'/></td>
                <td>{item.country}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_unit2'/></td>
                <td>{item.unit2}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_reportingType'/></td>
                <td>{item.reportingType}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_commercialValue'/></td>
                <td><FormattedCurrencyValue value={item.commercialValue}/></td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_transactionType'/></td>
                <td>{item.transactionType_str}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_commercialValue2'/></td>
                <td><FormattedCurrencyValue value={item.commercialValue2}/></td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_EORINRPSI'/></td>
                <td>{item.eorinrpsi}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_countryDispatch'/></td>
                <td>{item.countryDispatch}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_EORINRPSIAgent'/></td>
                <td>{item.eorinrpsiAgent}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_countryArrival'/></td>
                <td>{item.countryArrival}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_customsProcedureCode'/></td>
                <td>{item.customsProcedureCode}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_modeOfTransport'/></td>
                <td>{item.modeOfTransport}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_preferentialTreatment'/></td>
                <td>{item.customsProcedureCode}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_countryOrigin'/></td>
                <td>{item.countryOrigin}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_statisticalProcedure'/></td>
                <td>{item.statisticalProcedure}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_nationalityTransportMeans'/></td>
                <td>{item.nationalityTransportMeans}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_extrastatCode'/></td>
                <td>{item.extrastatCode}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_countryOfCustomsDeclaration'/></td>
                <td>{item.countryCustomsDeclaration}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_additionalDescription'/></td>
                <td>{item.additionalDescription}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_internalModeOfTransport'/></td>
                <td>{item.internalModeOfTransport}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_quantity1'/></td>
                <td>{item.quantity1}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_EUCountryOfDispatch'/></td>
                <td>{item.euCountryDispatch}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_unit1'/></td>
                <td>{item.unit1}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_EUCountryOfArrival'/></td>
                <td>{item.euCountryArrival}</td>
              </tr>
              <tr>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_quantity2'/></td>
                <td>{item.quantity2}</td>
                <td className="semi-bold"><LanguageStringResolver string='transactionInvoice_ExtrastatContainer'/></td>
                <td>{item.extrastatContainer}</td>
              </tr>
            </tbody>
          </table>
        ))}
      </div>
   );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(ReportExtrastat);
